<template>
	<div>
		<div class="container-fluid">
            <h1 class="mt-4 ml-2 h3 mb-0 text-gray-800">Painel</h1>
            <div class="row">
				<div class="col-md-12">
					<painel-financeiro
						:date="date">
					</painel-financeiro>
				</div>
			</div>
			<painel-totais-pedidos :dados="dados"></painel-totais-pedidos>
			<div class="row mt-4">
				<div class="col-md-6 mb-4">
					<chart-pedidos 
						:dados="dadosChart" 
						:key="chartPedidoKey">
					</chart-pedidos>
				</div>
				<div class="col-md-6 mb-4">
					<financeiro-chart-bar
						:date="date">
					</financeiro-chart-bar>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				date: '',
				dados: [],
				dadosChart: [],
				chartPedidoKey: 1
			}
		},
		created(){
			this.setDate();
			this.getDados();
			this.getDadosChart();
		},
		methods: {
			setDate(){
				var d = new Date();
				// Dia atual
				var day = d.getDate();
				if(day < 10){
					day = "0"+day
				}
				// Mês atual
				var month = d.getMonth() + 1;
				if(month < 10){
					month = "0"+month
				}
				this.date = d.getFullYear()+'-'+month+'-'+day;
			},
			getDadosChart(){
				axios.get(this.$url+'/api/adm/painel/data-chart')
	            .then(response => {
	            	this.dadosChart = response.data
	            	this.chartPedidoKey += 1
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			getDados(){
				axios.get(this.$url+'/api/adm/painel/data')
	            .then(response => {
	            	this.dados = response.data
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			}
		}
	}
</script>